import React from "react";
import { useCustomPropertyFilterStringValue } from "../../../state/FilterContext";

interface CustomFilterProps {
    name: string,
}

/***
 * A source component that returns the value of a custom filter.
 * 
 * Params:
 *      name: The name of the custom filter
 */
export const CustomFilter = React.memo(function CustomFilter({ name }: CustomFilterProps): React.ReactElement {
    const customProperty = useCustomPropertyFilterStringValue(name);
    return <>{customProperty}</>;
});